import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
export function LongTestimonials() {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré al club con el plan exacto de la clase. Las progresiones del Tomo 1 son exactamente lo que necesitaba para mis grupos de distintos niveles. Nunca más improviso.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Entrenadora de Tenis en Club'
  }, {
    quote: 'El Tomo 2, el de Planificación Anual, me cambió todo. Ahora tengo los 12 meses organizados y mis alumnos ven una progresión real. La retención mejoró muchísimo.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'Entrenadora de Tenis en Academia'
  }, {
    quote: 'El sistema de tácticas del Tomo 3 es único en el mercado. Los patrones de juego están descritos con diagrama de cancha y ejercicio incluido. Antes tardaba horas armando una clase táctica. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Entrenadora de Tenis Grupal e Individual'
  }, {
    quote: 'El Banco de Drills del Bono 2 eliminó el problema del grupo heterogéneo. Ahora cada alumno trabaja en su nivel con el drill correcto y saben exactamente qué necesitan para subir. Los avanzados se sienten desafiados y los principiantes se sienten seguros.',
    name: 'Luciana P.',
    location: 'Tucumán',
    role: 'Entrenadora Particular y en Academia'
  }, {
    quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de planificación mensual del Tomo 2 y la variedad de los 6 tomos. Los alumnos ahora quieren venir porque siempre hay algo nuevo.',
    name: 'Marcela G.',
    location: 'Mendoza',
    role: 'Entrenadora de Tenis Online y Presencial'
  }, {
    quote: 'Los 100 ejercicios del Bono 1 me salvaron. Ahora tengo drills para 3 meses de clases distintas sin repetir. Mis alumnos no pueden creer la variedad que tenemos clase a clase.',
    name: 'Laura V.',
    location: 'Santa Fe',
    role: 'Entrenadora de Tenis en Estudio Propio'
  }, {
    quote: 'El Tenis Pro Avanzado me cambió la cabeza. Nunca había dimensionado todo lo que me faltaba para profesionalizar mis clases, trabajar con jugadores de competencia y empezar a cobrar lo que realmente merezco.',
    name: 'Ana R.',
    location: 'Salta',
    role: 'Entrenadora de Tenis en Academia Independiente'
  }];
  return <section className="py-12 md:py-20 bg-cream bg-court-pattern-dark" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="text-center mb-10 md:mb-16" data-id="element-178">
          <h2 className="text-2xl md:text-4xl font-display text-navy-900 mb-3 md:mb-4" data-id="element-179">
            Lo que dicen los entrenadores que ya lo usan:
          </h2>
          <p className="text-base md:text-xl text-terracotta font-bold" data-id="element-180">
            +500 entrenadores de tenis de todo el país ya tienen su MEGAPACK
            TENIS RESUELTO
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-6 space-y-4 md:space-y-6" data-id="element-181">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="break-inside-avoid" data-id="element-182">
              <TestimonialCard {...t} dark={i % 2 !== 0} data-id="element-183" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}